import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const PricingPage = () => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const plans = [
        {
            name: t("subscription.free.title"),
            price:"0€",
            description: t("subscription.free.description"),
            features: [
                t("pricing.free.feature1"),
                t("pricing.free.feature2"),
                t("pricing.free.feature3"),
                t("pricing.free.feature4"),   
            ]
        },
        {
            name: t("subscription.pro.title"),
            price:"9,99€",
            description: t("subscription.pro.description"),
            features: [
                t("pricing.pro.feature1"),
                t("pricing.pro.feature2"),
                t("pricing.pro.feature3"),
                t("pricing.pro.feature4"),
            ]
        }
    ];

    return (
        <div className="-mt-16 min-h-screen bg-gray-100 py-8 px-4">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-2xl md:text-4xl font-bold text-center mb-8">{t("subscription.title")}</h1>
            <div className="grid md:grid-cols-2 gap-4 md:gap-8">
              {plans.map((plan) => (
                <Card key={plan.name}>
                  <CardContent className="p-4 md:p-6">
                    <div className="text-center mb-4 md:mb-8">
                      <h3 className="text-xl md:text-2xl font-bold">{plan.name}</h3>
                      <p className="text-xs md:text-base text-gray-500 mt-1">{plan.description}</p>
                    </div>
    
                    <div className="text-center mb-4 md:mb-8">
                      <p className="text-2xl md:text-4xl font-bold">{plan.price}</p>
                      {plan.price !== '0€' && (
                        <p className="text-xs md:text-sm text-gray-500 mt-1">/{t("subscription.month")}</p>
                      )}
                    </div>
    
                    <ul className="space-y-2 md:space-y-4 mb-4 md:mb-8">
                      {plan.features.map((feature,index) => (
                        <li key={index} className="flex items-start gap-2">
                          <Check className="h-4 w-4 md:h-5 md:w-5 text-green-500 flex-shrink-0 mt-0.5"/>
                          <span className="text-xs md:text-sm">{feature}</span>
                        </li>
                      ))}
                    </ul>
    
                    <button 
                      className="w-full py-2 md:py-3 text-xs md:text-sm rounded-lg font-medium text-white bg-blue-600 hover:bg-blue-700"
                      onClick={() => navigate('/signup')}
                    >
                      {plan.name === t("subscription.free.title")
                        ?  t("subscription.signForFree")
                        : `${t("subscription.subscribeTo")} ${plan.name}`
                      }
                    </button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      );
}

export default PricingPage;